import React from 'react';
import { DropletIcon, PlayCircleIcon } from 'lucide-react';
import { useScrollAnimation } from './useScrollAnimation';
export function WhyChooseUsSection() {
  const ref = useScrollAnimation();
  return <section id="why-choose-us" className="w-full py-20 px-4" style={{
    backgroundColor: '#0283C7'
  }} data-id="element-267">
      <div className="max-w-7xl mx-auto" ref={ref} data-id="element-268">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-269">
          {/* Left Content */}
          <div className="lg:col-span-7" data-id="element-270">
            <div className="flex items-center gap-2 mb-3 scroll-animate" data-id="element-271">
              <DropletIcon className="h-5 w-5 text-white opacity-80" data-id="element-272" />
            </div>
            <p className="uppercase tracking-widest font-semibold mb-3 scroll-animate" style={{
            color: 'rgba(255,255,255,0.8)',
            fontFamily: 'Inter, sans-serif',
            fontSize: '12px',
            letterSpacing: '0.2em',
            transitionDelay: '0.05s'
          }} data-id="element-273">
              Why Choose Us
            </p>
            <h2 className="font-bold text-white mb-5 scroll-animate" style={{
            fontFamily: 'Montserrat, sans-serif',
            fontSize: 'clamp(26px, 4vw, 38px)',
            fontWeight: 800,
            lineHeight: 1.1,
            transitionDelay: '0.1s'
          }} data-id="element-274">
              The Arizona Power Wash Difference
            </h2>
            <p className="mb-10 scroll-animate" style={{
            color: 'rgba(255,255,255,0.82)',
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            lineHeight: 1.7,
            transitionDelay: '0.15s'
          }} data-id="element-275">
              Blue Cactus Power Washing is dedicated to providing Arizona homes
              and businesses with top-quality exterior cleaning services. We
              provide lasting results using only the highest quality materials
              and equipment, combined with years of cleaning experience.
            </p>

            {/* Steps */}
            <div className="flex flex-col gap-7 mb-10" data-id="element-276">
              {[{
              n: 1,
              title: 'Consult',
              desc: 'Get a personalized consultation to assess your power washing needs with expert advice.',
              delay: '0.2s'
            }, {
              n: 2,
              title: 'Plan',
              desc: 'Receive a customized cleaning plan tailored to your property for optimal results.',
              delay: '0.3s'
            }, {
              n: 3,
              title: 'Clean',
              desc: 'Experience professional power washing that leaves your property spotless and pristine.',
              delay: '0.4s'
            }].map(step => <div key={step.n} className="flex gap-5 items-start scroll-animate" style={{
              transitionDelay: step.delay
            }} data-id="element-277">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-lg border-2 border-white" style={{
                backgroundColor: 'rgba(255,255,255,0.15)',
                color: '#ffffff',
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-278">
                    {step.n}
                  </div>
                  <div data-id="element-279">
                    <h3 className="font-bold text-white mb-1" style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '18px',
                  fontWeight: 700
                }} data-id="element-280">
                      {step.title}
                    </h3>
                    <p style={{
                  color: 'rgba(255,255,255,0.75)',
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '15px',
                  lineHeight: 1.6
                }} data-id="element-281">
                      {step.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <a href="#video" className="font-semibold flex items-center gap-2 transition-opacity hover:opacity-75 w-fit scroll-animate" style={{
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif',
            fontSize: '16px',
            transitionDelay: '0.5s'
          }} data-id="element-282">
              <PlayCircleIcon className="h-6 w-6" data-id="element-283" />
              View Our Story
            </a>
          </div>

          {/* Right Image */}
          <div className="lg:col-span-5 scroll-animate" style={{
          transitionDelay: '0.2s'
        }} data-id="element-284">
            <div className="relative overflow-hidden" style={{
            borderRadius: '12px',
            height: '500px',
            border: '4px solid rgba(255,255,255,0.9)'
          }} data-id="element-285">
              <div className="absolute inset-0 parallax-bg" style={{
              backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rcfrv9mcuJhBgKdMuti8S7/468426143_17913611199038692_8405045004997169730_n.jpg)',
              backgroundAttachment: 'fixed',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }} data-id="element-286" />
              <div className="absolute inset-0" style={{
              background: 'linear-gradient(to bottom, transparent 60%, rgba(2,131,199,0.3) 100%)'
            }} data-id="element-287" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}